import { render, staticRenderFns } from "./Transfers.vue?vue&type=template&id=cf374dce&"
import script from "./Transfers.vue?vue&type=script&lang=ts&"
export * from "./Transfers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports